import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PropertyService } from '../../services/property.service';

@Component({
  selector: 'app-statement-view',
  templateUrl: './statement-view.component.html',
  styleUrls: ['./statement-view.component.scss']
})
export class StatementViewComponent implements OnInit, OnDestroy {
  fileUrl: SafeResourceUrl | null = null;
  isPdf = false;
  propertyId: string | null = null;
  fileName: string | null = null;
  /** PDF bytes rendered inline by app-pdf-canvas-viewer. */
  pdfBytes: ArrayBuffer | null = null;
  pdfObjectUrl: string | null = null;
  renderFailed = false;
  loadError = false;
  private objectUrl: string | null = null;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private propertyService: PropertyService,
              private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.propertyId = this.route.snapshot.queryParamMap.get('propertyId');
    this.fileName = this.route.snapshot.queryParamMap.get('fileName');
    if (this.propertyId && this.fileName) {
      this.isPdf = this.fileName.toLowerCase().endsWith('.pdf');
      this.propertyService.getStatementFile(this.propertyId, this.fileName).then((blob: Blob) => {
        if (this.isPdf) {
          const pdfBlob = new Blob([blob], { type: 'application/pdf' });
          this.objectUrl = URL.createObjectURL(pdfBlob);
          this.pdfObjectUrl = this.objectUrl;
          return this.readBlobAsArrayBuffer(pdfBlob).then(buffer => {
            this.pdfBytes = buffer;
          });
        }
        this.objectUrl = URL.createObjectURL(blob);
        this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.objectUrl);
      }).catch(err => {
        console.error('Error loading statement file:', err);
        this.loadError = true;
      });
    }
  }

  ngOnDestroy() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
    }
  }

  openPdf() {
    if (this.pdfObjectUrl) {
      window.location.href = this.pdfObjectUrl;
    }
  }

  private readBlobAsArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as ArrayBuffer);
      reader.onerror = () => reject(reader.error || new Error('Failed to read statement'));
      reader.readAsArrayBuffer(blob);
    });
  }

  close() {
    if (this.propertyId) {
      this.router.navigate(['property-statements'], { queryParams: { propertyId: this.propertyId } });
    } else {
      this.router.navigate(['property-statements']);
    }
  }
}
